import { AreaLabels } from './beatArea'

/** The translated labels the area picker and the list's area column share. */
export const areaLabels = (t: (key: string) => string): AreaLabels => ({
  municipalitiesGroup: t('beats.municipalitiesGroup'),
  townsGroup: t('beats.townsGroup'),
  municipalitySuffix: t('beats.municipalitySuffix')
})
